/* ------------------------------------------------------------
   Skoop - product page -> ingredients glossary deep link

   Sends the "Full ingredients glossary" link through to the
   glossary with that product's filter already applied, e.g.
   /pages/ingredients-glossary#pitt-stop

   The glossary section already reads location.hash and clicks the
   matching product pill, so we only need to add the hash here.

   Links that already point at a specific ingredient (#ing-...)
   are left untouched. Bundles and kits have no single filter, so
   they fall through and land on the full glossary.
   ------------------------------------------------------------ */
(function () {
  var FILTER_BY_HANDLE = {
    'pitt-stop-natural-deodorant': 'pitt-stop',
    'skin-shield-anti-chafe-balm': 'skin-shield',
    'skin-shield-active': 'skin-shield',
    'hand-hero-antiperspirant-dry-touch-hand-cream': 'hand-hero',
    'babe-blotter-extra-drip-copy': 'babe-blotter',
    'babe-blotter-5-pack': 'babe-blotter',
    'babe-blotter-extra-drip': 'extra-drip',
    'babe-blotter-extra-drip-5-pack': 'extra-drip'
  };

  function run() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;

    var filter = FILTER_BY_HANDLE[match[1]];
    if (!filter) return;

    var links = document.querySelectorAll('a[href*="/pages/ingredients-glossary"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('#') > -1) continue;
      links[i].setAttribute('href', href + '#' + filter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


/* ------------------------------------------------------------
   Skoop - product page social strip

   The UGC video row is a normal theme section (id "ugc") so it
   stays editable in the theme editor, but on a product page it
   belongs inside the buy column, where the old Tolstoy widget
   used to sit: under the add-to-cart, above the trust row.

   Shopify renders sections in template order, so we move the
   node into place on load. Sections declared in a JSON template
   get a generated wrapper id (shopify-section-template--<id>__ugc),
   which is why this matches on the suffix. The CSS keeps it
   hidden until the move lands, then dresses it down for the
   narrow column.
   ------------------------------------------------------------ */
(function () {
  function place() {
    var buy = document.getElementById('sk2-pd-buy');
    var sec =
      document.querySelector('[id^="shopify-section-"][id$="__ugc"]') ||
      document.getElementById('shopify-section-ugc');
    if (!buy || !sec) return;
    if (sec.getAttribute('data-sk-ugc-placed') === '1') return;

    var anchor = buy.querySelector('.sk2-pd__trust');
    if (anchor) {
      buy.insertBefore(sec, anchor);
    } else {
      buy.appendChild(sec);
    }
    sec.setAttribute('data-sk-ugc-placed', '1');
    sec.classList.add('sk-ugc-ready');

    /* The section's own arrows step a fixed 564px, which overshoots
       badly at this card size. Clone them to drop those listeners
       and scroll by a screenful of the row instead. */
    var row = sec.querySelector('[data-vd-row]');
    if (!row) return;
    [['[data-vd-prev]', -1], ['[data-vd-next]', 1]].forEach(function (pair) {
      var btn = sec.querySelector(pair[0]);
      if (!btn) return;
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function () {
        row.scrollBy({ left: pair[1] * row.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  document.addEventListener('shopify:section:load', place);
})();


/* ------------------------------------------------------------
   Skoop - 30 day money back guarantee

   Reassurance belongs at the decision point, so this goes directly under
   the add-to-cart button rather than down in the tabs. Inserted
   here so every product template picks it up from one place.
   ------------------------------------------------------------ */
(function () {
  var TEXT = 'We back it. 30 days, money back guarantee.';

  function place() {
    var buy = document.getElementById('sk2-pd-buy');
    if (!buy) return;
    if (buy.querySelector('.sk-guar')) return;

    /* Sit above the social strip if it has already been moved in,
       so the running order stays: add to cart, guarantee, videos. */
    var anchor =
      buy.querySelector('[id$="__ugc"]') || buy.querySelector('.sk2-pd__trust');
    if (!anchor) return;

    var el = document.createElement('div');
    el.className = 'sk-guar';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1 3 5v6c0 5.25 3.84 10.16 9 11.4 5.16-1.24 9-6.15 9-11.4V5l-9-4zm-1.2 15.2L7 12.4l1.4-1.4 2.4 2.4 5-5L17.2 10l-6.4 6.2z"/></svg>' +
      '<span></span>';
    el.querySelector('span').textContent = TEXT;
    buy.insertBefore(el, anchor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  document.addEventListener('shopify:section:load', place);
})();


/* ------------------------------------------------------------
   Skoop - product page lightbox

   Two galleries share one overlay: the product photos (which on
   desktop are all on screen at once, so there was nothing to
   click) and the social video strip. Videos reopen with sound
   and controls, and the muted autoplaying card underneath is
   paused while the overlay is up so you don't hear it twice.

   Arrows and the keyboard move within whichever group you
   opened, so photos and videos never mix in one sequence.
   ------------------------------------------------------------ */
(function () {
  var lb, stage, count, items = [], idx = 0, paused = null;

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'sk-lb';
    lb.innerHTML =
      '<button class="sk-lb__btn sk-lb__close" aria-label="Close">&#10005;</button>' +
      '<button class="sk-lb__btn sk-lb__prev" aria-label="Previous">&#8592;</button>' +
      '<div class="sk-lb__stage"></div>' +
      '<button class="sk-lb__btn sk-lb__next" aria-label="Next">&#8594;</button>' +
      '<div class="sk-lb__count"></div>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.sk-lb__stage');
    count = lb.querySelector('.sk-lb__count');

    lb.querySelector('.sk-lb__close').addEventListener('click', close);
    lb.querySelector('.sk-lb__prev').addEventListener('click', function (e) {
      e.stopPropagation();
      go(-1);
    });
    lb.querySelector('.sk-lb__next').addEventListener('click', function (e) {
      e.stopPropagation();
      go(1);
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  }

  function render() {
    var item = items[idx];
    stage.innerHTML = '';
    if (paused) { try { paused.play(); } catch (e) {} paused = null; }

    if (item.type === 'video') {
      var v = document.createElement('video');
      v.src = item.src;
      if (item.poster) v.poster = item.poster;
      v.controls = true;
      v.playsInline = true;
      v.autoplay = true;
      stage.appendChild(v);
      /* Hush the little card behind the overlay. */
      if (item.el) {
        var card = item.el.querySelector('video');
        if (card && !card.paused) { card.pause(); paused = card; }
      }
    } else {
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      stage.appendChild(img);
    }
    count.textContent = items.length > 1 ? idx + 1 + ' / ' + items.length : '';
    var many = items.length > 1;
    lb.querySelector('.sk-lb__prev').style.display = many ? '' : 'none';
    lb.querySelector('.sk-lb__next').style.display = many ? '' : 'none';
  }

  function go(step) {
    if (!items.length) return;
    idx = (idx + step + items.length) % items.length;
    render();
  }

  function open(list, start) {
    build();
    items = list;
    idx = start;
    render();
    lb.classList.add('is-open');
    document.body.classList.add('sk-lb-open');
  }

  function close() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.classList.remove('sk-lb-open');
    stage.innerHTML = '';
    if (paused) { try { paused.play(); } catch (e) {} paused = null; }
  }

  function wire() {
    /* Product photos */
    var wrap = document.querySelector('.sk2-pd__mainwrap');
    if (wrap && !wrap.getAttribute('data-sk-lb')) {
      wrap.setAttribute('data-sk-lb', '1');
      wrap.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('.sk2-pd__media-item img') : null;
        if (!img) return;
        var all = [].slice.call(wrap.querySelectorAll('.sk2-pd__media-item img'));
        open(
          all.map(function (n) {
            return { type: 'image', src: n.currentSrc || n.src, alt: n.alt };
          }),
          all.indexOf(img)
        );
      });
    }

    /* Social strip */
    var strip = document.querySelector('[id$="__ugc"] [data-vd-row]');
    if (strip && !strip.getAttribute('data-sk-lb')) {
      strip.setAttribute('data-sk-lb', '1');
      strip.addEventListener('click', function (e) {
        var card = e.target.closest ? e.target.closest('.sk2-vd__card') : null;
        if (!card) return;
        var cards = [].slice.call(strip.querySelectorAll('.sk2-vd__card'));
        var list = cards.map(function (c) {
          var v = c.querySelector('video');
          var s = v && v.querySelector('source');
          return {
            type: 'video',
            src: (s && s.getAttribute('src')) || (v && v.currentSrc) || '',
            poster: v ? v.getAttribute('poster') : '',
            el: c
          };
        });
        open(list, cards.indexOf(card));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
  setTimeout(wire, 800);
})();


/* ------------------------------------------------------------
   Skoop - "Why we back it" accordion

   Appends one more tab to the product accordions, matching the
   theme's own <details> markup so it looks and behaves native.
   Lives here rather than in each of the seven product templates
   because the copy is identical on every product - one place to
   edit beats seven copies drifting apart.

   Country of origin is deliberately "Australian owned" only: the
   range is not all manufactured in Australia, and this block
   renders on every product.
   ------------------------------------------------------------ */
(function () {
  var HEADING = 'Why we back it';
  var BODY =
    '<p><strong>We back it. 30 days, money back guarantee.</strong></p>' +
    '<p>Two years of R&amp;D went into these formulas, and constant testing on ' +
    'real bodies having real sweaty days. Australian owned, female founded, ' +
    'plant powered and never tested on animals.</p>' +
    '<p>If it is not working for you, get in touch within 30 days of your order ' +
    'and we will sort you out. See <a href="/pages/shipping-and-returns">Shipping &amp; Returns</a> ' +
    'for the details.</p>';

  function place() {
    var tabs = document.querySelector('.sk2-pd__tabs');
    if (!tabs) return;
    if (tabs.querySelector('[data-sk-guar-tab]')) return;

    var d = document.createElement('details');
    d.className = 'sk2-pd__tab';
    d.setAttribute('data-sk-guar-tab', '1');
    d.innerHTML =
      '<summary></summary><div class="sk2-pd__tab-body">' + BODY + '</div>';
    /* Shield + label grouped so the summary's space-between keeps the
       plus on the right instead of scattering all three. */
    var s = d.querySelector('summary');
    var left = document.createElement('span');
    left.className = 'sk-guar-sum';
    left.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1 3 5v6c0 5.25 3.84 10.16 9 11.4 5.16-1.24 9-6.15 9-11.4V5l-9-4zm-1.2 15.2L7 12.4l1.4-1.4 2.4 2.4 5-5L17.2 10l-6.4 6.2z"/></svg>';
    left.appendChild(document.createTextNode(HEADING));
    s.appendChild(left);
    var ic = document.createElement('span');
    ic.className = 'sk2-pd__tab-ic';
    ic.textContent = '+';
    s.appendChild(ic);

    tabs.appendChild(d);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  document.addEventListener('shopify:section:load', place);
})();
